import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <Link to={"/about"} style={{ color: "white" }}>
        About
      </Link>
    </footer>
  );
};

export default Footer;
